// src/components/YepModel.js
import React, { useRef, useMemo } from 'react';
import { useGLTF } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

export function YepModel(props) {
    const { scene } = useGLTF('/model.glb'); // Убедись, что путь к твоей модели верный
    const modelRef = useRef();

    // Вращение модели
    useFrame((state, delta) => {
        if (modelRef.current && props.isRotating) {
            modelRef.current.rotation.y += delta * 0.4; // Замедленное вращение
        }
    });

    // Создаем материал для модели один раз
    const material = useMemo(() =>
        new THREE.MeshStandardMaterial({
            color: new THREE.Color(props.color || "#0A0A0A"), // Черный металлик
            metalness: props.metalness !== undefined ? props.metalness : 0.95,
            roughness: props.roughness !== undefined ? props.roughness : 0.45,
        }), [props.color, props.metalness, props.roughness]);

    // Клонируем сцену и применяем материал
    const clonedScene = useMemo(() => {
        const clone = scene.clone();

        // Важно: если опорная точка твоей GLB модели не у ее основания, а, например, в центре,
        // то здесь нужно будет сделать смещение, чтобы "поставить" модель на ее основание.
        // Предположим, modelEffectiveHeight - это полная высота модели.
        // const scale = props.scale || 1.0; // props.scale приходит из modelTransform
        // const offsetY = (props.modelEffectiveHeight || 2.0) * scale / 2;
        // clone.position.y = -offsetY; // Сдвигаем геометрию вниз

        clone.traverse((child) => {
            if (child.isMesh) {
                child.material = material;
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });
        return clone;
    }, [scene, material /*, props.scale, props.modelEffectiveHeight */]); // Добавь зависимости, если используешь offsetY

    return (
        <primitive
            ref={modelRef}
            object={clonedScene}
            scale={props.scale}
            position={props.position}
            rotation={props.rotation}
        />
    );
}

useGLTF.preload('/model.glb');